import { createRoute, Outlet } from '@tanstack/react-router';
import { z } from 'zod/v3';

import { menuLayoutRoute } from 'root/MenuLayout';
import RequireWarehouse from 'root/RequireWarehouse';

import { AddToInventoryView } from './AddToInventoryView/AddToInventoryView';
import ReceivingEnabledRoute from './ReceivingEnabledRoute';
import { ReceivingView } from './ReceivingView/ReceivingView';

const receivingRootRoute = createRoute({
  getParentRoute: () => menuLayoutRoute,
  id: 'receiving-root-route',
});

const ReceivingRequireWarehouse = () => {
  return (
    <RequireWarehouse
      routeWithWarehouseId="/receiving/warehouse/$warehouseId"
      routeWithoutWarehouseId="/receiving"
    >
      <Outlet />
    </RequireWarehouse>
  );
};

const requireWarehouseRoute = createRoute({
  getParentRoute: () => receivingRootRoute,
  path: '/receiving',
  component: ReceivingRequireWarehouse,
});

const receivingEnabledRoute = createRoute({
  getParentRoute: () => requireWarehouseRoute,
  id: 'receiving-enabled-route',
  component: ReceivingEnabledRoute,
});

const receivingWarehouseWrapperRoute = createRoute({
  getParentRoute: () => receivingEnabledRoute,
  path: 'warehouse',
});

export const receivingRoute = createRoute({
  getParentRoute: () => receivingWarehouseWrapperRoute,
  path: '$warehouseId',
  component: ReceivingView,
  parseParams: z.object({ warehouseId: z.string().uuid() }).parse,
  validateSearch: z.object({
    showRecentlyAdded: z.boolean().optional(),
    showUserGuides: z.boolean().optional(),
    searchFromCatalog: z.boolean().optional(),
    confirmItem: z.string().optional(),
    searchQuery: z.coerce.string().optional(),
  }).parse,
});

export const addToInventoryRoute = createRoute({
  getParentRoute: () => receivingWarehouseWrapperRoute,
  path: '$warehouseId/$itemId',
  component: AddToInventoryView,
  validateSearch: z.object({
    searchQuery: z.coerce.string().optional(),
    inboundLoadId: z.string().optional(),
  }).parse,
  parseParams: z.object({ warehouseId: z.string().uuid(), itemId: z.string() }).parse,
});

export const receivingRouteTree = receivingRootRoute.addChildren({
  requireWarehouseRoute: requireWarehouseRoute.addChildren({
    receivingEnabledRoute: receivingEnabledRoute.addChildren({
      receivingWarehouseWrapperRoute: receivingWarehouseWrapperRoute.addChildren({
        receivingRoute,
        addToInventoryRoute,
      }),
    }),
  }),
});
